module.exports = __webpack_public_path__ + "static/media/image-app-detail@2x.194c38fd.png";